
















































































































































































































































































































import {
  ComponentInternalInstance,
  computed,
  defineComponent,
  getCurrentInstance,
  onMounted,
  onUnmounted,
  reactive,
  ref,
  toRefs,
  unref,
  watch,
} from '@vue/composition-api';
import {
  ArrowLeftIcon,
  ChevronDownIcon,
  EllipsisIcon,
  DownloadIcon,
  ShareIcon,
  FolderIcon,
  StarIcon,
  StarFilledIcon,
  UserIcon,
} from 'tdesign-icons-vue';

// 引入组件
import Menu from '@/renderer/components/Menu/Menu.vue';
import MenuItem from '@/renderer/components/Menu/MenuItem.vue';
import StatusTag from '@/renderer/components/SpacePage/components/StatusTag.vue';
import WemeetLinkShare from '@/renderer/components/dialog/linkShare/WemeetShare.vue';
import linkShare from '@/renderer/components/dialog/linkShare/index.vue';
import AddFileAuth from '@/renderer/components/dialog/AddTransfer/AddFileAuth/index.vue';
import renameFolderDialog from '@/renderer/components/dialog/rename.vue';
import RefreshableHeader from '@/renderer/components/SpacePage/components/RefreshableHeader.vue';
import FileApply from '@/renderer/views/desktop/FileManagement/FileApply/index.vue';
import FileApplyDialog from '@/renderer/components/dialog/FileApply/components/FileApplyDialog.vue';

// 引入 compositions
import FileIcon from '@/renderer/components/Base/BaseTableFileIcon/FileIcon.vue';
import authHandler from '@/renderer/components/SpacePage/compositions/authHandler';
import deleteHandler from '@/renderer/components/SpacePage/compositions/deleteHandler';
import downloadHandler from '@/renderer/components/SpacePage/compositions/downloadHandler';
import extraFileInfoHandler from '@/renderer/components/SpacePage/compositions/extraFileInfoHandler';
import openPreviewHandler from '@/renderer/components/SpacePage/compositions/openPreviewHandler';
import renameHandler from '@/renderer/components/SpacePage/compositions/renameHandler';
import linkShareHandler from '@/renderer/components/dialog/linkShare/composition/linkShareHandler';
import dynamicOpenHandler from '@/renderer/components/drawer/Dynamic/composition/dynamicOpenHandler';
import listOperateHandler from '@/renderer/scripts/composition/listOperateHandler';
import { fileLocationHandler } from '@/renderer/views/desktop/FileManagement/RelatedToMe/composition/fileLocationHandler';
import { relatedToMeDrawerHandler } from '@/renderer/views/desktop/FileManagement/RelatedToMe/composition/relatedToMeDrawerHandler';
import relatedToMeListHandler from '@/renderer/views/desktop/FileManagement/RelatedToMe/composition/relatedToMeListHandler';
import { setResizableColumns } from '@/renderer/scripts/composition/tableResizeHandler';

// 引入工具类
import i18n, { i18n_t } from '@/locales/i18n';
import { checkIfMobileStyle } from '@/renderer/scripts/composition/dialogHandler';
import { can, optAuth } from '@/renderer/scripts/composition/authHandler';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
import { GetDropdownItemShortCutText } from '@/renderer/scripts/utils/hotkeyDataHelper';
import ipc from '@/renderer/scripts/utils/ipc';
import storage from '@/renderer/scripts/utils/storage';
import tips from '@/renderer/scripts/utils/tips';
import {
  noPreview,
  isAllowPreviewImage,
  isAllowPrivate,
  isAllowEditDoc,
} from '@/renderer/scripts/composition/allowPreview';
import store from '@/renderer/store';
import { DrawerEvents } from '@/renderer/store/modules/drawer';
import smh, { SMH } from '@/renderer/scripts/smh';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { FileApplyPageData, FileCollectionListData } from '@/renderer/scripts/libs/smh-sdk-class/typings';
import { overCurrentTime } from '@/renderer/scripts/utils/dayjsUsage';
import { actionHandler } from '@/renderer/components/SpacePage/compositions/actionHandler';
import { openFolderOrDirectory } from '@/renderer/scripts/utils/openFolderOrDirectory';

export default defineComponent({
  name: 'RelatedToMe',
  components: {
    FileIcon,
    ArrowLeftIcon,
    StatusTag,
    FileApply,
    renameFolderDialog,
    AddFileAuth,
    linkShare,
    ChevronDownIcon,
    Menu,
    MenuItem,
    WemeetLinkShare,
    StarIcon,
    StarFilledIcon,
    ShareIcon,
    FolderIcon,
    DownloadIcon,
    EllipsisIcon,
    RefreshableHeader,
    UserIcon,
    FileApplyDialog,
  },
  setup(props, context) {
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = context.root;
    const { $router, $store } = vm;
    const { query } = vm.$router.currentRoute;
    const requestPermissionVisible = ref(false);
    const currPath = ref('');
    const currentUser = computed(() => $store.getters.userBaseInfo);
    const { methods: fileLocationMethods } = fileLocationHandler();
    const {
      tableData,
      pageData,
      columns,
      loading,
      loadingOnHeader,
      sort,
      methods: relatedToMeListMethods,
    } = relatedToMeListHandler();
    const resizeColumns = ref(setResizableColumns(columns));
    const collectData = reactive<{
      users: SMH.FileCollectionListData[];
      total: number;
    }>({
      users: [],
      total: 0,
    });
    const fileApplyData = reactive<FileApplyPageData>({
      contents: [],
      totalNum: 0,
    });
    const {
      operateShowMap,
      isFirstButtonHover,
      isSecondButtonHover,
      isThirdButtonHover,
      hoverIndex,
      spaceId,
      isDropdownShow,
      methods: listOperateMethods,
    } = listOperateHandler(tableData);
    const {
      show: showRename,
      originName: fromName,
      type: renameType,
      methods: renameMethods,
      renameError,
    } = renameHandler(spaceId);
    const { show: showLink, showWemeetShare, linkData, methods: linkShareMethods } = linkShareHandler(spaceId);
    const { methods: downloadMethods } = downloadHandler(spaceId);
    const { methods: deleteMethods } = deleteHandler(spaceId);
    const { show: showAuth, authParams, teamId: authTeamId, methods: authMethods } = authHandler(spaceId);
    const { methods: previewMethods } = openPreviewHandler(spaceId);
    const { methods: extraFileInfoMethods } = extraFileInfoHandler(spaceId);
    const { setDefaultDrawer } = relatedToMeDrawerHandler(spaceId);
    setDefaultDrawer();
    dynamicOpenHandler();

    /**
     * 是否是临时用户或者用户不存在
     */
    const isTemporaryOrUserNoExist = computed((): boolean => {
      const { userBaseInfo } = $store.getters;
      const { userId, isTemporary } = userBaseInfo;
      return userId === -1 || isTemporary;
    });
    const noDisableRoleSelect = computed(() => tableData.selectedList[0]?.spaceTag === 'personal');
    const focusList = () => {
      const { filePageRef }: any = (currComponent as ComponentInternalInstance).refs;
      filePageRef.focus({
        preventScroll: true,
      });
    };
    const { actionMethods, filterMethods } = actionHandler();

    const methods = {
      renderDropdownItemOptions(item: SMH.RelatedToMeFileItemData): Array<{
        content: string;
        value: string;
      }> {
        let actionMap: Record<string, boolean> = {
          preview: optAuth('Preview', item),
          edit: optAuth('Edit', item),
          rename: can('Modify', item),
          addFavorite: !item.favorited,
          delFavorite: item.favorited,
          auth: item.spaceTag !== 'group' && can('Authorize', item),
          requestPermission: true,
          delete: can('Delete', item),
        };
        actionMap = filterMethods.filterAll(actionMap, item);
        actionMethods.calcOptionsByActionMap(actionMap);
        return actionMethods.calcOptionsByActionMap(actionMap);
      },
      async onEventProxy(command: string, item: any, index: number) {
        currPath.value = item.path.slice(0, item.path.length - 1).join('/');
        const routerPath = item.path.join('/');
        spaceId.value = item.spaceId;
        switch (command) {
          case 'download':
            downloadMethods.prepareDownload([item]);
            break;
          case 'delete':
            deleteMethods.confirmDelete([item], false, () => {
              focusList();
            });
            break;
          case 'rename':
            renameMethods.openRenameFolder(item);
            break;
          case 'openFolder':
            if (!item.visible) {
              tips.error(i18n_t('已被删除，请前往误删恢复找回'));
              return;
            }
            if (item.type === 'dir') {
              openFolderOrDirectory({ item, isOpenFolder: true, targetRouteName: 'relatedToMeFileList' });
            } else if (noPreview(item)) {
              tips.error(i18n_t('该格式暂不支持在线预览'));
            } else if (!can('Preview', item)) {
              tips.error(i18n_t('暂无在线预览权限，请联系管理员'));
            } else if (isAllowPreviewImage(item.name) && item.size >= ConstantConfig.ciImageMaxSize) {
              // 万象最大支持32mb
              tips.error(i18n_t('文件过大，请下载至本地查看'));
            } else if (!store.getters.enableDocPreview && !isAllowPrivate(item.name)) {
              if (isAllowEditDoc(item.name)) {
                tips.error(i18n_t('当前文件暂未接入文档预览与编辑服务，请下载至本地查看'));
              } else {
                tips.error(i18n_t('该文件暂不支持预览，请下载至本地查看'));
              }
            } else {
              // 计算preview页面的数据加载需要从第几页加载，preview默认pageSize为10条
              const { currPage, pageSize } = pageData;
              const previewPage = Math.ceil(((currPage - 1) * pageSize + index + 1) / ConstantConfig.previewPageSize);
              previewMethods.openPreview(item, 1);
            }
            break;
          case 'openOriginDirectroy':
            {
              if (!item.isUserBelongSpace) {
                tips.error(i18n_t('未加入对应空间'));
                return;
              }
              openFolderOrDirectory({ item, isOpenFolder: false });
            }
            break;
          case 'share':
            {
              const shareData = [item];
              if (shareData.length === 1 && store.getters.isInWeMeetApp) {
                shareData[0] = {
                  ...shareData[0],
                  canPreview: optAuth('Preview', item),
                  canEdit: optAuth('Edit', item),
                };
              }
              linkShareMethods.openShare(shareData);
            }
            break;
          case 'addFavorite':
            extraFileInfoMethods.addFavorite(item, tableData.list);
            break;
          case 'delFavorite':
            extraFileInfoMethods.delFavorite([item.favoriteId], tableData.list);
            break;
          case 'edit':
            await previewMethods.openEdit(item);
            break;
          case 'preview':
            if (isAllowPreviewImage(item.name) && item.size >= ConstantConfig.ciImageMaxSize) {
              // 万象最大支持32mb
              tips.error(i18n_t('文件过大，请下载至本地查看'));
            } else if (!store.getters.enableDocPreview && !isAllowPrivate(item.name)) {
              if (isAllowEditDoc(item.name)) {
                tips.error(i18n_t('当前文件暂未接入文档预览与编辑服务，请下载至本地查看'));
              } else {
                tips.error(i18n_t('该文件暂不支持预览，请下载至本地查看'));
              }
            } else {
              previewMethods.openPreview(item, 1);
            }
            break;
          // 授权即邀请协作
          case 'auth':
            {
              if (checkIfMobileStyle()) return;
              const params = {
                path: item.path.join('/'),
                userId: item.userId,
                spaceTag: item.spaceTag,
                virusAuditStatus: item.virusAuditStatus,
                teamId: item.team?.id,
              };
              const canOpenAuthDialog = authMethods.canOpenAuthDir(params);
              if (!canOpenAuthDialog) return;
              Object.assign(authParams, { params });
              showAuth.value = true;
            }
            break;
          case 'requestPermission':
            requestPermissionVisible.value = true;
            break;
          default:
            tips.success(i18n_t('敬请期待...'));
            break;
        }
      },
      // 添加选中态类
      renderRowClass(params: any) {
        return tableData.selectedRowKeys.join(',') === params?.row.id.toString() ? 'is-selected' : '';
      },
      async refreshList() {
        // 先做界面UI，此时会先增加ipc.on 再刷新
        setDefaultDrawer();
        await relatedToMeListMethods.refresh();
      },
      silentRefreshList() {
        setDefaultDrawer();
        relatedToMeListMethods.silentRefresh();
      },
      canPreview(item: any): boolean {
        return item.type !== 'dir' && optAuth('Preview', item);
      },
      goFileCollect(type: 'relatedToMe' | 'approval') {
        dispatchRouter({
          name: 'fileCollect',
          query: {
            tab: type === 'relatedToMe' ? 'hasCollected' : 'hasLaunched',
          },
        });
      },
      goFileApply(type: 'applying' | 'myApply' | 'historyApply') {
        dispatchRouter(
          {
            name: 'fileApply',
            query: {
              tab: type,
            },
          },
          'replace',
        );
      },
    };
    watch(
      () => tableData.selectedList,
      (newList, oldList) => {
        ipc.emit(ipc.RENDERER_EVENTS_MAP.ON_SELECTED_CHANGE, unref(newList), unref(oldList));
      },
    );

    watch(
      () => [showWemeetShare.value, showAuth.value, showRename.value, showLink.value],
      () => {
        if (!showWemeetShare.value && !showAuth.value && !showRename.value && !showLink.value) {
          focusList();
        }
      },
    );

    onMounted(() => {
      // 重命名和删除刷下列表
      ipc.on(ipc.RENDERER_EVENTS_MAP.COMMAND_REFRESH, methods.refreshList);
    });
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.COMMAND_REFRESH, methods.refreshList);
    });
    const init = async () => {
      // 异步任务需await一下 才能获取到total的值
      await methods.refreshList();
      if (!isTemporaryOrUserNoExist.value) {
        getLaunchedAndReceivedFileCollectionList();
      }
    };
    init();
    const getLaunchedAndReceivedFileCollectionList = async () => {
      // 为了查询所有任务的状态，减少多个请求,超过6个头像就隐藏了
      const opt = {
        page: 1,
        pageSize: 1000,
      };
      try {
        const [{ data: receivedData }, { data: launchedData }, { data: auditData }] = await Promise.all([
          smh.userAPI.getReceivedFileCollectionList(opt),
          smh.userAPI.getLaunchedFileCollectionList(opt),
          smh.userAPI.getFileApplyList({
            page: 1,
            pageSize: 6,
            type: 'my_audit',
            status: 'auditing',
          }),
        ]);

        Object.assign(fileApplyData, auditData);
        [...receivedData.contents, ...launchedData.contents].forEach((item: SMH.FileCollectionListData) => {
          if (item.status && item.path && !overCurrentTime(new Date(), item.expireTime)) {
            collectData.total++;
            collectData.users.push(item);
          }
        });
      } catch (e) {
        tips.error(e as MsgError);
      }
    };
    const handleHotKeyAction = (action: string): boolean => {
      // 过滤t-dialog弹窗打开的情况
      if (
        loading.value ||
        tableData.selectedRowKeys.length <= 0 ||
        !tableData.selectedList[0].visible ||
        [...document.getElementsByClassName('t-dialog__ctx')].filter(e => (e as HTMLElement).style.display !== 'none')
          .length > 0
      ) {
        return false;
      }
      switch (action) {
        case 'rename':
          if (can('Modify', tableData.selectedList[0])) {
            methods.onEventProxy(action, tableData.selectedList[0], 0);
            return true;
          }
          break;
        case 'download':
          if (optAuth('Download', tableData.selectedList[0] as any)) {
            methods.onEventProxy(action, tableData.selectedList[0], 0);
            return true;
          }
          break;
        case 'share':
          if (can('Share', tableData.selectedList[0])) {
            methods.onEventProxy(action, tableData.selectedList[0], 0);
            return true;
          }
          break;
        case 'delete':
          if (can('Delete', tableData.selectedList[0])) {
            methods.onEventProxy(action, tableData.selectedList[0], 0);
            return true;
          }
          break;
        case 'open':
          methods.onEventProxy('openOriginDirectroy', tableData.selectedList[0], Number(tableData.selectedRowKeys[0]));
          return true;
        case 'addFavorite':
        case 'delFavorite':
          if (tableData.selectedRowKeys.length === 1) {
            if (!tableData.selectedList[0].favorited) {
              methods.onEventProxy('addFavorite', tableData.selectedList[0], 0);
            } else {
              methods.onEventProxy('delFavorite', tableData.selectedList[0], 0);
            }
            return true;
          }
          break;
        default:
          break;
      }

      return false;
    };
    return {
      requestPermissionVisible,
      showLink,
      showWemeetShare,
      linkData,
      ...toRefs(tableData),
      ...toRefs(pageData),
      resizeColumns,
      loading,
      loadingOnHeader,
      sort,
      can,
      optAuth,
      showAuth,
      authTeamId,
      showRename,
      fromName,
      renameType,
      renameError,
      operateShowMap,
      isDropdownShow,
      isFirstButtonHover,
      isSecondButtonHover,
      isThirdButtonHover,
      hoverIndex,
      listOperateMethods,
      collectData,
      fileApplyData,
      ...relatedToMeListMethods,
      ...methods,
      renameMethods,
      noDisableRoleSelect,
      authParams,
      authMethods,
      handleHotKeyAction,
      isTemporaryOrUserNoExist,
      GetDropdownItemShortCutText,
    };
  },
});
